import { MAGIC_COOKIES } from '@app/shared/constants/cookiesShop';
import { MagicCookie } from '@app/shared/ui/molecules/Common';

interface CookiesListSectionProps {
  onCookiesClick: (price: string) => void;
}

export function CookieListSection({ onCookiesClick }: CookiesListSectionProps) {
  return (
    <section className="grid grid-cols-2 gap-5 px-4">
      {MAGIC_COOKIES.map((cookie) => (
        <div key={cookie.price} onClick={() => onCookiesClick(cookie.cookieAmount.toString())}>
          <MagicCookie key={cookie.price} size="lg" magicCookie={cookie} />
        </div>
      ))}
    </section>
  );
}
